import { Injectable } from '@angular/core';
import { LoginTwoFactorContext } from '@core/models';

@Injectable({ providedIn: 'root' })
export class TwoFactorWorkflowStore {
  private loginContext?: LoginTwoFactorContext;
  setLogin(context: LoginTwoFactorContext): void { this.loginContext = context; }
  getLogin(): LoginTwoFactorContext | undefined { return this.loginContext; }
  clearLogin(): void { this.loginContext = undefined; }
}
